import api from './axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/v1';

const apiCall = async (endpoint, method = 'GET', data = null) => {
  const config = {
    method,
    url: endpoint,
    data
  };

  try {
    const response = await api(config);
    return response.data;
  } catch (error) {
    // Rethrow the error to be caught by the calling function
    throw error;
  }
};

export default apiCall; 